export enum ProposalReportEvaluationType {
    ReportEvaluation = 1,
    BudgetEvaluation = 2
  }
  